export enum NotificationsHubRoutes {
  NotificationsTemplates = 'notifications-templates',
  NotificationsScheduler = 'notifications-scheduler',
  NotificationsChannels = 'notifications-channels',
  DynamicSegments = 'dynamic-segments',
  DynamicLists = 'dynamic-lists',
  EmailTemplates = 'email-templates',
  EmailBlocks = 'email-blocks',
  GlobalBlocks = 'global-blocks',
}
